import { Configuration } from "@azure/msal-browser";

export const msalConfig: Configuration = {
  auth: {
    clientId: process.env.REACT_APP_CLIENT_ID || "", // Provide a fallback value if necessary
    authority: process.env.REACT_APP_AUTHORITY || "",
    redirectUri: window.location.origin, // Dynamic redirect URI
    postLogoutRedirectUri: window.location.origin, // Dynamic post-logout redirect URI
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: false,
  },
  system: {
    tokenRenewalOffsetSeconds: 10 * 60, // 10 minutes
  },
};

export const loginRequest = {
  scopes: ["openid", "offline_access", process.env.REACT_APP_API_SCOPES || ""], // Provide a fallback value if necessary
  authority: process.env.REACT_APP_AUTHORITY || "",
};
